<ng-template #title><ng-content select="[title]"></ng-content></ng-template>
<ng-template #filter><ng-content select="[filter]"></ng-content></ng-template>

<div data-at-sidenav class="sidenav-panel" [class.condensed]="condensed">
  <div
    data-at-title
    *ngIf="!condensed"
    class="panel-title flex flex-col gap-[20px] lt-sm:gap-[10px]"
  >
    <div
      data-at-title-content
      class="flex flex-row gap-[20px] lt-sm:gap-[10px] justify-start items-center"
    >
      <vi-icon-button data-at-close-btn (click)="closePanel()">clear</vi-icon-button>
      <ng-container *ngTemplateOutlet="title"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="filter"></ng-container>
  </div>

  <div
    data-at-title
    *ngIf="condensed"
    class="panel-title flex flex-col gap-[20px] lt-sm:gap-[10px]"
  >
    <div
      data-at-title-content
      class="flex flex-row gap-[20px] lt-sm:gap-[10px] justify-start items-center"
    >
      <vi-icon-button data-at-close-btn (click)="closePanel()">clear</vi-icon-button>
      <ng-container *ngTemplateOutlet="title"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="filter"></ng-container>
  </div>

  <div data-at-tabs class="panel-tabs">
    <ng-content select="[tabs]"></ng-content>
  </div>
  <div class="panel-content flex flex-col gap-[60px] lt-md:gap-[20px]" #panelContentRef>
    <div data-at-content class="panel-content-inner">
      <ng-content select="[content]"></ng-content>
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
